export default "__VITE_ASSET__CA7q5tUR__"